import { render } from "./GradeLevel.vue?vue&type=template&id=71d98c36&scoped=true"
import script from "./GradeLevel.vue?vue&type=script&lang=js"
export * from "./GradeLevel.vue?vue&type=script&lang=js"

import "./GradeLevel.vue?vue&type=style&index=0&id=71d98c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d98c36"]])

export default __exports__